import { WaterInvoiceApproveStatus } from "../enums/global.enums";

export function approveStatusPipe(value: string) {
    switch (value) {
        case WaterInvoiceApproveStatus.All: return "Tất cả";
        case WaterInvoiceApproveStatus.NotApprove: return "Chưa phê duyệt";
        case WaterInvoiceApproveStatus.Approved: return "Phê duyệt";
    }
    return "";
}
